import { useTranslation } from 'react-i18next'

const SiblingEnd = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="sibling-end-title"
      {...props}
    >
      <title id="sibling-end-title">{t('antagonists:sibling:components:end')}</title>
      <path
        d="m1456.32 551.46 58.76-3.1s8.61 108.75 4.27 152.03-7.6 119.75.92 140.38c8.52 20.63 6.73 33.3 8.84 45.78 2.09 12.46 3.64 30.44 3.64 30.44s-8.46 3.89-13.16-4.93c-4.68-8.82-4.52-19.95-11.11-18.11-6.59 1.85-.41 19.17 4.1 24.09 4.52 4.91 17.23 8.7 20.38 13.47 3.15 4.77 4.05 12.39 4.05 12.39s-27.96-7.26-36.31-10.05c-8.35-2.79-18.79-31.97-21.75-41.46-2.95-9.49 8.23-23.69 2.61-45.42s-31.9-129.1-35.9-158.75c-4-29.65 1.4-39.97-.2-56.29-.88-8.98 10.87-80.47 10.87-80.47h-.02ZM1767.14 558.26l-79.18 22.16s9.51 113.15 14.87 156.3c5.35 43.15 10.41 119.54 2.38 140.37-8.03 20.83-5.96 33.47-7.76 45.98-1.8 12.51-2.92 30.51-2.92 30.51s8.55 3.69 13.03-5.24c4.48-8.93 4.05-20.05 10.69-18.36 6.63 1.69.86 19.17-3.55 24.18-4.41 5.02-17.03 9.09-20.05 13.93s-3.76 12.48-3.76 12.48 27.78-7.92 36.08-10.89c8.28-2.99 18.04-32.4 20.78-41.95 2.72-9.56-4.77-39.97.34-61.82 5.11-21.86 29.38-125.84 32.66-155.58 3.29-29.74.32-40.85 1.55-57.21.67-9-15.14-94.84-15.14-94.84l-.02-.02Z"
        style={{
          fill: '#e0a758',
        }}
      />
      <path
        d="M1486.95 762.23s-45.42 137.68-56.94 186.69c-11.52 48.99-31.22 133.81-35.83 153.53-8.5 36.31 5.11 135.11 3.37 173.28-1.73 38.17 1.73 92.84 1.73 92.84s26.9 10.41 45.11 8.68c18.22-1.73 35.43-8.55 35.43-8.55s19.5-140.31 27.29-172.81c4.61-19.24 73.97-183.9 73.97-183.9s.31 98.46 2.93 140.1c3.74 59.26 17.34 224.15 17.34 224.15s12.21 3.6 40.85 3.6 41.64-6.07 41.64-6.07 0-39.91 4.34-77.21 15.61-99.77 13.88-130.14c-1.73-30.37 45.98-203.88 58.99-260.28 13.02-56.4-29.87-186.26-29.87-186.26l-244.26 42.36h.02Z"
        style={{
          fill: '#6d9454',
        }}
      />
      <path
        d="m1727.39 639.82.05 1.22c-.18-.76-.27-1.17-.27-1.17l.22-.05Z"
        style={{
          fill: '#efbbba',
        }}
      />
      <path
        d="m1727.73 642.23 72.86-20.92s-9.27-40.42-15.84-72.39c-5.76-28.12-24.09-87.64-36.76-102.44-7.83-9.15-47.53-12.24-61.3-17.88 3.47 31.58-43.62 26.1-65.94 26.41-23.46.32-43.87-24.57-47.67-29.61-4.01.63-25.55 4.5-29.6 5.22-13.27 2.39-50.91 6.21-68.63 24.56-25.11 26.01-53.34 160.44-53.34 160.44s51.85 16.99 74.17 23.46c.4 28.08-7.04 48.73-21.33 95.2-11.11 36.11-27.4 126.29-27.4 126.29s88.81 3.76 164.65 7.83c75.85 4.07 166.11-22.41 166.11-22.41s-9.29-60.9-24.39-97.56c-15.84-38.45-22.18-91.72-25.58-106.25v.05Z"
        style={{
          fill: '#efbbba',
        }}
      />
      <path
        d="M1598.17 294.38c-19.01 1.82-59.59 17.03-59.59 17.03s-5.38 56.67 10.89 74.64c6.99 7.71 14.26 13.21 21.71 17.23.18 3.28-.47 6.34-.74 9.49-1.35 15.16-1.24 14.04-1.24 14.04s5.9 35.34 53.52 34.51c33.83-.58 40.69-14.42 35.61-13.12.11-2.03-19.48-23.57-16.22-32.93 6.05-17.43 15.73-32.66 18.79-52.78 3.15-20.7 1.67-39.48 1.76-51.4-10.78-1.51-45.4-18.56-64.49-16.74l-.02.04Z"
        style={{
          fill: '#e0a758',
        }}
      />
      <path
        d="M1738.34 424.04c-5.36-18.81-28.26-76.21-33.09-94.08-25.42-94.37-44.5-113.36-110.21-107.21-57.7 5.4-64.68 56.4-71.29 110.81-4.64 38.27 7.6 67.71 25.62 96.17 5.87-1.06 19.96-2.75 19.96-2.75s.27-.76 1.75-13.99c.34-3.15.29-6.41.11-9.69-7.45-4.01-14.74-9.52-21.71-17.23-16.27-17.97-10.89-74.64-10.89-74.64s41.6-9.58 60.61-11.4c19.08-1.82 50.95 9.65 61.73 11.16-.09 11.92-6.12 33.56-9.27 54.24-3.06 20.13-7.65 47.33-17.07 76.24-8.1 24.9-21.51 57.18-21.51 57.18l103.19 5.74s35.75-32.6 22.09-80.56h-.02Z"
        style={{
          fill: '#feca21',
        }}
      />
      <path
        d="M1598.2 365.96c3.8-1.06 5.94.4 8.25.22 2.56-.2 2.39-1.64 7.47.25 2 .76 6.23 3.53 7.51 4.1 3.83 1.76 6.25.83 7.13 3.6 1.28 4.05-3.29 8.1-6.46 11.07-4.64 4.34-5.13 8.14-16.6 8.21-11.88.09-13.05-4.46-16.63-7.69-2.84-2.56-6.84-7.22-6.19-11.59.45-3.11 4.54-3.53 7.71-4.37 1.69-.45 5.67-3.2 7.83-3.8Zm-2.12 11.76c.54 1.78 3.01 3.83 9.78 3.76 6.77-.07 10.06-2.5 9.4-4.73-.54-1.78-5.11-3.29-10.39-3.04-7.65.36-9.11 2.92-8.77 4.01h-.02Z"
        style={{
          fill: '#d78b3b',
        }}
      />
      <path
        style={{
          fill: '#008db5',
        }}
        d="m1559.39 327.43 8.15 3.15 1.16-3.16-8.1-3.23-1.21 3.24z"
      />
      <path
        d="M1571.6 323.91c-4.05.31-6.7 3.24-6.26 7.2s3.15 5.38 6.79 5.35c4.3-.04 6.57-2.83 6.53-6.93-.04-2.9-2.9-5.9-7.06-5.6v-.02ZM1643.86 326.64l-8.32 4.47-1.46-3.03 8.27-4.53 1.51 3.09z"
        style={{
          fill: '#008db5',
        }}
      />
      <path
        d="M1630.21 324.21c4.05-.31 7.11 2.2 7.27 6.17.16 3.98-2.3 5.8-5.9 6.3-4.27.59-6.91-1.8-7.49-5.87-.41-2.88 1.96-6.28 6.14-6.61h-.02Z"
        style={{
          fill: '#008db5',
        }}
      />
      <path
        style={{
          fill: '#235a96',
        }}
        d="m1621.79 317.5 22.1 3.13.6-4.84-21.57-2.36-1.13 4.07zM1560.78 322.81l21.11-6.11-1.31-4.37-21.53 5.8 1.73 4.68z"
      />
    </svg>
  )
}

export default SiblingEnd
